__turbopack_context__.v({
  "aspect164": "index-module-scss-module__9gwEEW__aspect164",
  "aspect169": "index-module-scss-module__9gwEEW__aspect169",
  "wrapper": "index-module-scss-module__9gwEEW__wrapper",
});
